import React from 'react';
import { DialogTrigger } from 'react-aria-components';
import { ModalContent } from './Content.es.js';
import { ModalContentBody } from './ContentBody.es.js';
import { ModalContentFooter } from './ContentFooter.es.js';
import { ModalContentHeader } from './ContentHeader.es.js';

const ModalRoot = ({ children, isOpen, onOpenChange }) => {
  return React.createElement(DialogTrigger, { isOpen, onOpenChange }, children);
};
const Modal = {
  Content: ModalContent,
  ContentBody: ModalContentBody,
  ContentFooter: ModalContentFooter,
  ContentHeader: ModalContentHeader,
  Root: ModalRoot
};

export { Modal, ModalRoot, Modal as default };
//# sourceMappingURL=Modal.es.js.map
